module.exports = __webpack_public_path__ + "img/Pot3.9d5c7632.svg";